import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-axisNaming",
  "use": "icon-axisNaming-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-axisNaming\"><path d=\"M908.8 946.347H94.72a32 32 0 110-64H908.8a32 32 0 010 64zM439.04 743.253H239.787A32 32 0 01208 713.6l-16-206.933a32 32 0 018.107-23.68l367.36-413.014a32 32 0 0122.613-10.666 32.64 32.64 0 0123.467 8.96l214.826 207.146A32 32 0 01830.08 320L462.933 732.587a32 32 0 01-23.893 10.666zm-169.6-64h155.093L761.6 299.947l-168.533-162.56-336 378.026z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol